import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';

registerFragment('chroa-mwmbership-card', (fragmentElement, configuration, meta) => {});

if (import.meta.hot) {
    import.meta.hot.accept();
}



